const en = {
  title: 'Our Website Uses Cookies',
  description:
    ' By continuing to use our site, you agree to our use of cookies to\n' +
    'support your experience.',
  ok: 'Accept',
};

export default en;
